import {action, computed, makeObservable, observable} from 'mobx'
import {v4} from 'uuid'
import {TimeSeries} from 'components/project/model/TimeSeries'
import {SensitivityVar} from 'components/project/model/SensitivityVar'
import {MultiYearVar} from 'components/project/model/MultiYearVar'
import { MultiYearTimeSeries } from 'components/project/model/MultiYearTimeSeries'

export type EnergyMarketKind = 'dam' | 'fmm' | 'rtm'

export const allEnergyMarkets: EnergyMarketKind[] = ['dam', 'fmm', 'rtm']

export const getEnergyMarketKindLabel = (kind: EnergyMarketKind) => {
    switch (kind) {
        case 'dam':
            return 'Day-ahead'
        case 'fmm':
            return 'Fifteen-minute'
        case 'rtm':
            return 'Real-time'
    }
}


export class EnergyMarket {
    constructor(lifetime: number) {
        makeObservable(this)
        this.priceEscalator.updateLifetime(lifetime)
    }
    id: string = v4()

    @observable kind: EnergyMarketKind = 'dam'
    @observable useMultiYearPrice: boolean = false
    @observable price: TimeSeries = new TimeSeries()
    @observable multiYearPrice: MultiYearTimeSeries[] = new Array<MultiYearTimeSeries>()
    @observable priceAverage: SensitivityVar = new SensitivityVar() // ($/MWh)
    @observable priceEscalator: MultiYearVar = new MultiYearVar() // (%)
    @observable allocation: number = 100
    @observable allocationSensitivity: SensitivityVar = new SensitivityVar(100) // (%)
    @observable maxStorageCommitmentSensitivity: SensitivityVar = new SensitivityVar(100) // (%)
    @observable windAllocationSensitivity: SensitivityVar = new SensitivityVar(100) // (%)
    @observable pvAllocationSensitivity: SensitivityVar = new SensitivityVar(100) // (%)


    @computed get name(): string { return getEnergyMarketKindLabel(this.kind) }

    @action setAllocation(x: number) { this.allocation = x }

    @action setData(data: number[], year: number) {
        this.price.setData(data, year)
        const average = this.price.calculateAverage()
        this.priceAverage.setSingleValue(average)
    }

    //@action setMultiData(data)
    @action setUseMultiYearPrice(x: boolean) {this.useMultiYearPrice = x}
}
